module.exports = __webpack_public_path__ + "img/Event1.55b12d8d.jpg";